module.exports = __webpack_public_path__ + "static/media/Simisage_gaussian2.175fdd5a.png";